import { useState } from 'react'

type CarouselImageLazyLoadingParams = {
  offset: number
}

const useCarouselImageLazyLoading = ({ offset }: CarouselImageLazyLoadingParams) => {
  const [lastVisibleImageIndex, setLastVisibleImageIndex] = useState<number>(0)

  const handleImageLazyLoading = ({ lastVisibleItemIndex }) => {
    if (lastVisibleItemIndex > lastVisibleImageIndex) {
      setLastVisibleImageIndex(lastVisibleItemIndex)
    }
  }

  const lastImageIndexLoaded = offset + lastVisibleImageIndex
  return { handleImageLazyLoading, lastImageIndexLoaded }
}

export default useCarouselImageLazyLoading
